import React from 'react';

interface ReportSubsectionProps {
  title: string;
  children: React.ReactNode;
  className?: string;
}

export const ReportSubsection: React.FC<ReportSubsectionProps> = ({
  title,
  children,
  className = ''
}) => {
  return (
    <div className={`mb-8 ${className}`}>
      <h3 className="text-xl font-semibold text-gray-800 mb-4">{title}</h3>
      {children}
    </div>
  );
};
